import script from "./TeamList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamList.vue?vue&type=script&lang=ts&setup=true"

import "./TeamList.vue?vue&type=style&index=0&id=ecfa3d62&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecfa3d62"]])

export default __exports__